import { slaDisplays, slaTypes } from '@/components/Account/SLARequirements/constants';

/**
 * The shipper's SLA requirements as page sections, one per SLA type in the shipper tab's order.
 * Each type's free text becomes one item per non-empty line.
 * @param {Object<string, string> | null} settings `clients.special_instructions_settings`
 * @returns {{ id: string, title: string, items: string[], emptyText: string }[]}
 */
export const getSlaSections = (settings) =>
    slaTypes.map((type) => ({
        id: type,
        title: slaDisplays[type] || type,
        items:
            typeof settings?.[type] === 'string'
                ? settings[type].split(/\r?\n/).flatMap((line) => line.trim() || [])
                : [],
        emptyText: 'No requirements set.',
    }));
